export default class FileUploadUtils
  @upload_form: (form, success, cancel, failure) ->
    $form = $(form)

    formData = new FormData($form.get(0))
    formData.append('contently_upload_xhr', true)
    @send($form.attr('action'), null, formData, success, cancel, failure)

  @upload: (url, auth_token, file, success, cancel, failure) ->
    @validate_params(url, file)

    fd = new FormData()
    fd.append("file", file)

    @send(url, fd, success, success, failure)

  @upload_with_data: (url, auth_token, data, success, cancel, failure) ->
    @validate_params(url, data)

    fd = new FormData()

    for key, value of data
      fd.append(key, value)

    @send(url, auth_token, fd, success, cancel, failure)

  @load_locally: (file, context, on_load) ->
    @validate_browser_support()

    reader = new FileReader()
    reader.onload =
      (e) ->
        on_load.call(context, e.target.result)

    reader.readAsDataURL(file)

  @send: (url, auth_token, form_data, success, cancel, failure) ->
    xhr = new XMLHttpRequest()
    xhr.addEventListener("load", success, false)
    xhr.addEventListener("abort", cancel, false)
    xhr.addEventListener("error", failure, false)
    xhr.open("POST", url)
    xhr.setRequestHeader("X-CSRF-Token", auth_token) if auth_token
    xhr.send(form_data)

  @validate_params: (url, data) ->
    if !url or url == null or url == ""
      throw "You must provide a valid url for the file upload ajax request"
    else if !data or data == null
      throw "You must provide a valid file or data hash to upload a file"

  @validate_browser_support: ->
    if !window.File or !window.FileReader or !window.FileList or !window.Blob
      throw "This browser does not support html5 file loading, please implement a try/catch to alert the user"



// WEBPACK FOOTER //
// ./app/javascript/utils/shared/file_upload_utils.js.coffee